var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('h1',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.$t('about.title')))]),_c('HomeHero'),(!_vm.isSmallScreen)?_c('HomeNews'):_vm._e(),_c('HomeComparison'),_c('HomeProducts'),_c('HomeSEO'),_c('HomeTour')],1)}
var staticRenderFns = []

export { render, staticRenderFns }